import MessagingRoutesContactsHandler from './contacts-handler.js';

export default class MessagingRoutesComposeContactsHandler extends MessagingRoutesContactsHandler {
  titleKey = 'emc.contacts_page.new_message';
  ctaKey = 'emc.contacts_page.create';
  showListSections = true;
  showEmptyStateBanner = true;
  showNoSearchResultsBanner = true;

  get multiSelect() {
    return this.messaging.groupMessagingEnabled;
  }

  get showScopeIndicator() {
    return this.messaging.groupMessagingEnabled;
  }

  augmentFilter(filter, { relatedClientsOnly } = {}) {
    if (relatedClientsOnly) {
      return { ...filter, related_clients_only: true };
    }
    return filter;
  }

  submit(selectedContacts) {
    return this.openConversationWithContacts(selectedContacts);
  }

  leave() {
    return this.messagingNavigation.goToPreviousRoute();
  }
}
